import React from 'react';
import PropTypes from 'prop-types';
import { Grid, FormLabel, Checkbox } from '@mui/material';

const UserGroupItemComponent = ({ userGroup, selectedUserGroup, dispatch }) => {
  const onClick = event => {
    if (event.target.checked)
      dispatch({
        type: 'OnXUserGroupAdded',
        userGroupId: userGroup.id
      });
    else
      dispatch({
        type: 'OnXUserGroupDeleted',
        userGroupId: userGroup.id
      });
  };

  return (
    <Grid item xs={12} sm={8}>
      <Checkbox checked={selectedUserGroup ? true : false} onClick={onClick} />
      <FormLabel>{userGroup.name}</FormLabel>
    </Grid>
  );
};

UserGroupItemComponent.propTypes = {
  selectedUserGroup: PropTypes.object,
  userGroup: PropTypes.object,
  dispatch: PropTypes.func
};

export default UserGroupItemComponent;
